import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import TGSiderBox from './tgSiderBox';
import IpadAd from '../../../components/ipadAd';

class TGNewsSider extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { tgNewsSiderContent, tgNewsSiderAd, ipadAd5 },
        } = this.props;

        return (
            <div id="techSiderList" className={styles.sider_box}>
                <div className={styles.sider}>
                    <Chip
                        id="50096"
                        type="struct"
                        title="科技要闻区左侧栏标题"
                        groupName="科技国学要闻区左侧栏"
                        content={tgNewsSiderContent}>
                        <TGSiderBox />
                    </Chip>
                </div>
                <NoSSR>
                    {tgNewsSiderAd ? (
                        <Ad content={tgNewsSiderAd} />
                    ) : (
                        <Chip id="40107" type="static" title="广告6" groupName="科技国学要闻区左侧栏" content={ipadAd5}>
                            <IpadAd />
                        </Chip>
                    )}
                </NoSSR>
            </div>
        );
    }
}

export default errorBoundary(TGNewsSider);
